import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import LegalPage from './pages/Legal';
import DespreNoi from './pages/DespreNoi';
import Parteneri from './pages/Parteneri';
import DispatcherDashboard from './pages/dispacer/DashboardDispacer';
import DriverDashboard from './pages/sofer/DriverDashboard';
import AuthProvider from './hooks/useAuth';
import ProtectedRoute from './components/others/ProtectedRoute';
import TrackPage from './pages/TrackPage';
import NotFoundPage from './pages/NotFoundPage';

function AppContent() {
  return (
    <Routes>
      {/* Rute publice */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/despre-noi" element={<DespreNoi />} />
      <Route path="/parteneri" element={<Parteneri />} />
      <Route path="/track/:token" element={<TrackPage />} />
      
      {/* Rute protejate cu roluri */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute requiredRoles={['admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dispacer"
        element={
          <ProtectedRoute requiredRoles={['dispacer']}>
            <DispatcherDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sofer"
        element={
          <ProtectedRoute requiredRoles={['sofer']}>
            <DriverDashboard />
          </ProtectedRoute>
        }
      />
      
      {/* Ruta 404 - trebuie să fie ultima */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    // Înregistrează service worker-ul
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      });
    }

    // Setează meta tag-urile pentru mobile
    const setMobileMetaTags = () => {
      // Viewport
      let viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) {
        viewport = document.createElement('meta');
        viewport.setAttribute('name', 'viewport');
        document.head.appendChild(viewport);
      }
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover');

      // Theme Color
      let themeColor = document.querySelector('meta[name="theme-color"]');
      if (!themeColor) {
        themeColor = document.createElement('meta');
        themeColor.setAttribute('name', 'theme-color');
        document.head.appendChild(themeColor);
      }
      themeColor.setAttribute('content', '#ffffff');

      // Apple Web App Meta Tags
      const appleMetaTags = [
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
        { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
        { name: 'apple-mobile-web-app-title', content: 'VGL Admin' }
      ];

      appleMetaTags.forEach(tag => {
        let meta = document.querySelector(`meta[name="${tag.name}"]`);
        if (!meta) {
          meta = document.createElement('meta');
          meta.setAttribute('name', tag.name);
          document.head.appendChild(meta);
        }
        meta.setAttribute('content', tag.content);
      });
    };

    setMobileMetaTags();

    // Previne zoom pe iOS
    const preventZoom = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    document.addEventListener('touchstart', preventZoom, { passive: false });
    document.addEventListener('gesturestart', (e) => e.preventDefault());

    return () => {
      document.removeEventListener('touchstart', preventZoom);
    };
  }, []);

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;